import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {devConfig, countries, profile, walletsList} from "config/config"; // Importing configuration settings

/**
 * Class representing the FilterGetReportStructureGamesView.
 * @extends JetView
 */
export default class FilterGetReportStructureGamesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service for translations
        const left = {
            id: "a1",
            margin: 5,
            rows: [
                {
                    responsive: "a1",
                    margin: 15,
                    css: "on-row",
                    cols: [
                        {
                            view: "datepicker", // Datepicker component for selecting a period
                            name: "period_time",
                            id: "period_time",
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _("Periodo"), // Label for the datepicker
                            labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                            format: "%d %M %Y", // Date format
                            suggest: {
                                type: "calendar",
                                body: {
                                    maxDate: new Date() // Maximum selectable date is today
                                }
                            }
                        },
                        {
                            id: "user_name",
                            name: "user_name",
                            view: "text", // Text input for user's full name
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("Nombre completo del jugador"), // Label for the text input
                            labelPosition: "top",
                            placeholder: _("Nombre"), // Placeholder text
                        },
                        {
                            view: "richselect", // Dropdown for selecting document type
                            name: "document_type",
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("Tipo Documento"), // Label for the dropdown
                            labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder text
                            value: "0", // Default value
                            options: [ // Options for the document type
                                {"id": "DNI", "value": _("DNI")},
                                {"id": "Cédula de extranjería", "value": _("Cédula de extranjería")},
                                {"id": "Pasaporte", "value": _("Pasaporte")}
                            ]
                        },
                        {
                            id: "DocumentNumber",
                            name: "document_number",
                            view: "text", // Text input for document number
                            type: "number",
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("Numero del documento"), // Label for the text input
                            labelPosition: "top",
                            placeholder: _("Numero"), // Placeholder text
                        },
                    ]
                },
                {
                    responsive: "a1",
                    margin: 15,
                    css: "on-row",
                    cols: [
                        {
                            id: "user_id",
                            name: "user_id",
                            view: "text", // Text input for user ID
                            type: "number",
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("ID Jugador"), // Label for the text input
                            labelPosition: "top",
                            placeholder: _("ID Jugador"), // Placeholder text
                            on: {
                                onChange: function(data, obj) { // Event handler for changes in user ID
                                    var currentValue = this.getValue(); // Get current value of user ID
                                    if (currentValue.length > 0 && $$("period_time").getValue().length > 0) {
                                        $$('consultDesk').enable(); // Enable consult button if conditions are met
                                    } else {
                                        $$('consultDesk').disable(); // Disable consult button otherwise
                                    }
                                }
                            }
                        },
                        {},
                        {},
                        {},
                    ]
                },
            ]
        };
        const upper_section = {
            css: "father-container",
            rows: [{
                margin: 10,
                cols: [
                    left // Include the left section in the upper section
                ]
            }]
        };
        const buttons = {
            cols: [
                {},
                {
                    view: "button", // Button to clear the form
                    value: _("Limpiar"),
                    width: (screen == "small") ? 0 : 100,
                    minWidth: 200,
                    click: () => { // Click event handler for clearing the form
                        $$('myForm').setValues($$('myForm').getCleanValues());
                        $$('CountrySelect').setValue(($$('myForm').getCleanValues()).CountrySelect);
                        $$('Datepicker').setValue(""); // Reset datepicker value
                    }
                },
                {
                    id: "consultDesk",
                    view: "button", // Button to consult the report
                    value: _("Consultar"),
                    disabled: true, // Initially disabled
                    hotkey: "enter", // Hotkey for the button
                    type: "form",
                    width: (screen == "small") ? 0 : 100,
                    click: () => { // Click event handler for consulting the report
                        const filterdata = this.getRoot().getValues(); // Get values from the form
                        filterdata.Country = profile.Settings.ReportCountry; // Set country from profile settings
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent("getReportStructureGames:filter", [filterdata]); // Call event to filter report
                        $$("b5").collapse(); // Collapse the filters section
                        $$('a5').scrollTo(100, 0); // Scroll to a specific position
                    }
                }
            ]
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: "button", // Button to clear the second form
                    value: _("Limpiar"),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues());
                        $$('CountrySelect').setValue(($$('myForm2').getCleanValues()).CountrySelect);
                        $$('Datepicker').setValue(""); // Reset datepicker value
                    }
                },
                {
                    id: "consultDesk",
                    view: "button", // Button to consult the report in the second form
                    disabled: true, // Initially disabled
                    value: _("Consultar"),
                    hotkey: "enter", // Hotkey for the button
                    type: "form",
                    click: () => { // Click event handler for consulting the report
                        const filterdata = $$('myForm2').getValues(); // Get values from the second form
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if configured
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent("getReportStructureGames:filter", [filterdata]); // Call event to filter report
                    }
                }
            ]
        };
        const accordion_section2 = {
            type: "wide",
            rows: [
                {
                    multi: true,
                    view: "accordion", // Accordion component for filters
                    css: "betShop",
                    collapsed: true,
                    type: "clean",
                    rows: [
                        {
                            id: "b5",
                            header: _("Filtros"), // Header for the filters section
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons] // Include upper section and buttons
                            }
                        }
                    ]
                }
            ]
        };
        const accordion_section3 = {
            view: "scrollview", // Scrollable view for the upper section
            scroll: "xy",
            body: {
                padding: 10,
                rows: [upper_section] // Include upper section
            }
        };
        const filterPopup = webix.ui({ // Popup window for filters
            view: "window",
            move: true,
            id: "filterPopup",
            fullscreen: true,
            modal: true,
            position: "center",
            head: {
                view: "toolbar",
                cols: [
                    {view: "label", label: _("Filtros"), align: "center"}, // Label for the popup
                    {
                        view: "icon", icon: "wxi-close", click: function () { // Close button for the popup
                            this.getTopParentView().hide(); // Hide the popup
                        }
                    }
                ]
            },
            body: {
                view: "form", id: 'myForm2', // Form inside the popup
                type: "clean",
                rows: [
                    accordion_section3, buttons2 // Include accordion section and buttons
                ],
                rules: {
                    "fname": webix.rules.isNotEmpty // Validation rule for the form
                }
            }
        });
        return {
            id: 'myForm',
            view: "form", // Main form for the view
            type: "clean",
            rows: [
                (screen.width > 500 && screen.height > 500) ? accordion_section2 : {height: 1, width: 0} // Conditional rendering based on screen size
            ],
            rules: {
                "fname": webix.rules.isNotEmpty // Validation rule for the form
            }
        };
    }
    /**
     * Initializes the view.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        webix.ready(function () { // Ready function for Webix
        });
    }
}

// FILE DOCUMENTED
